import month from './Months.js'
import weekday from './Weekdays.js'
import { LocaleTime } from '../../Types.js'

const time: LocaleTime = {
  month,
  weekday,
}

export default time
